import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 500 500"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M499.353 249.995a250.26 250.26 0 0 0-73.308-176.687A250.23 250.23 0 0 0 249.358 0c-331.652 13.713-331.577 486.325 0 500a250.26 250.26 0 0 0 176.687-73.308 250.27 250.27 0 0 0 73.308-176.687zM249.358 470.588c-58.494-.075-114.56-23.313-155.916-64.668-41.364-41.365-64.593-97.431-64.668-155.915 12.094-292.65 429.12-292.574 441.177 0-.076 58.494-23.313 114.56-64.669 155.915-41.364 41.355-97.43 64.593-155.915 64.668z" }, null, -1),
    _createElementVNode("path", { d: "m249.176 337.742-108.231-63.933 108.217 152.558L357.48 273.809l-108.348 63.933zm1.647-264.109L142.562 253.278l108.247 63.991 108.245-63.933z" }, null, -1)
  ])))
}
export default { render: render }